/**
 * Old public links used HashRouter (`/#/learn`, `/?billing=success#/profile`).
 * Rewrite those to history paths before the router reads the location.
 * Returns the replacement path, or null when the URL should stay as it is.
 */
const ANCHORS: Record<string, string> = {
  'how-it-works': '/how-it-works',
  pricing: '/pricing',
  'sign-in': '/login',
  learn: '/learn',
  tools: '/tools',
};

export function legacyHashPath(href: string): string | null {
  const url = new URL(href, 'https://thedealskout.com');
  const hash = url.hash;
  if (!hash || hash === '#') return null;

  let body = hash.slice(1);
  if (!body.startsWith('/')) {
    const mapped = ANCHORS[body];
    if (!mapped) return null;
    body = mapped;
  }

  const q = body.indexOf('?');
  const pathname = q === -1 ? body : body.slice(0, q);
  const hashQuery = q === -1 ? '' : body.slice(q + 1);
  const params = new URLSearchParams(url.search);
  if (hashQuery) {
    new URLSearchParams(hashQuery).forEach((value, key) => params.set(key, value));
  }
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return null;
  const search = params.toString();
  const next = `${pathname}${search ? `?${search}` : ''}`;
  const current = `${url.pathname}${url.search}`;
  if (next === current) return null;
  return next;
}

export function applyLegacyHashRedirect(): string | null {
  if (typeof window === 'undefined') return null;
  const next = legacyHashPath(window.location.href);
  if (!next) return null;
  window.history.replaceState(null, '', next);
  return next;
}
